import React from "react";
import useDataStore from "../../../../stores/dataStore";
import ContextMenuItem from "../../ContextMenuItem";
import { FaCode } from "react-icons/fa6";
import { IoDocumentTextSharp } from "react-icons/io5";
import { exportNoteData } from "../../../../utility/exportImportData";

function ExportTextFileContextMenu(props: { noteID: string }) {
    return (
        <div>
            <ContextMenuItem
                label="Plain Text"
                icon={<IoDocumentTextSharp size={14} />}
                callbackFunction={() => {
                    exportNoteData(props.noteID, true);
                }}
            />
            <ContextMenuItem
                label="Markdown"
                icon={<FaCode size={14} />}
                callbackFunction={() => {
                    exportNoteData(props.noteID, false);
                }}
            />
        </div>
    );
}

export default ExportTextFileContextMenu;
